module.exports = __webpack_public_path__ + "static/media/DSC_8451.1a2223f6.jpg";